import $axios from "@/api";

const prefixUrl = 'retur_penjualan'

const state = () => ({
    datas:{
        group: [],
        ungroup: [],
        detail_group:{}
    },
    show_modal_detail: false,

})


const mutations = {
    SET_DATAS(state, payload){
        state.datas[payload.target] = payload.data
    },
    SET_DETAIL_MODAL(state, payload) {
        state.show_modal_detail = payload
    },
}

const actions = {
    async getReturPenjualanGroup({commit}, params){
        try{
            const response = await $axios.get(`${prefixUrl}/groups`,{params:params})
            commit("SET_DATAS",{target:'group',data: response.data.data})
            return response.data.meta
        }catch(err){    
            console.log(err)
        }
    },
    async getReturPenjualanUngroup({commit}, params){
        try{
            const response = await $axios.get(`${prefixUrl}/ungroups`,{params:params})
            commit("SET_DATAS",{target:'ungroup',data: response.data.data})
            return response.data.meta
        }catch(err){    
            console.log(err)
        }
    },
    async setReturGroup({state}, payload) {
        try{
            const response = await $axios.post(`${prefixUrl}/group`,payload)
            return response.data
        }catch(err){    
            console.log(err)
        }
    },
    async showReturPenjualanGroup({commit}, id) {
        try{
            const response = await $axios.get(`${prefixUrl}/group/${id}`)
            commit("SET_DATAS",{target:'detail_group',data: response.data.data})
        }catch(err){    
            console.log(err)
        }
    },
    async countPrint({commit}, id) {
        try{
            const response = await $axios.put(`${prefixUrl}/group/print_count/${id}`)
            return response
        }catch(err){    
            console.log(err)
        }
    },
    async unsetFromGroup({commit}, id) {
        try{
            const response = await $axios.put(`${prefixUrl}/group/unset/${id}`)
            return response
        }catch(err){    
            console.log(err)
        }
    }

}

export default {
    namespaced: true,
    state,
    actions,
    mutations
}
